import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import TagManager from 'react-gtm-module'

const tagManagerArgs = process.env.NODE_ENV === 'production' ? {
  gtmId: process.env.REACT_APP_TAG_MANAGER_ID,
  auth: process.env.REACT_APP_TAG_MANAGER_AUTH,
  preview: process.env.REACT_APP_TAG_MANAGER_PREVIEW
} : {
  gtmId: process.env.REACT_APP_TAG_MANAGER_ID
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
      <ToastContainer />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
